var map = {
	"./CUIABA/logo.png": "f8V1",
	"./DOE-AL/logo.png": "zRJ2",
	"./PMVG/logo.png": "tbNJ",
	"./TCE-AL/logo.png": "bHm5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "boC1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens ^\.\/.*\/logo\.png$
// module id = boC1
// module chunks = 1